/* Jackie-Codex: image-mega-menu v1.0.0 — accessibility, image resize, Theme Editor. */
(() => {
  if (window.jackieImageMenuV1) return;
  window.jackieImageMenuV1 = true;
  function setup(scope = document) {
    scope.querySelectorAll('mega-menu.jackie-image-menu').forEach(menu => {
      if (menu.dataset.jackieReady) return;
      menu.dataset.jackieReady = 'true';
      const trigger = menu.querySelector('.header__menu-item--top');
      const panel = menu.querySelector('.list-menu-dropdown');
      const sync = () => trigger.setAttribute('aria-expanded', String(menu.classList.contains('is-active')));
      new MutationObserver(sync).observe(menu, {attributes:true, attributeFilter:['class']});
      new ResizeObserver(() => {
        if (menu.classList.contains('is-active') && menu.header && typeof menu.showSublist === 'function') menu.showSublist();
      }).observe(panel);
      trigger.addEventListener('click', event => {
        if (trigger.getAttribute('href') === '#') {event.preventDefault(); menu.handleMouseover?.();}
      });
      menu.addEventListener('keydown', event => {
        if (event.key === 'Escape') {event.preventDefault(); event.stopPropagation(); trigger.focus(); menu.close?.();}
      });
      sync();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup()); else setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
  document.addEventListener('shopify:block:select', event => {
    const id = event.detail?.blockId;
    if (!id) return;
    const candidates = [...document.querySelectorAll('[data-jackie-block]')].filter(el => el.dataset.jackieBlock === id);
    const menu = candidates.find(el => el.getClientRects().length && el.matches('mega-menu'));
    if (menu) {menu.handleMouseover?.(); return;}
    const drawer = candidates.find(el => el.matches('details'));
    if (drawer) {
      const outer = drawer.closest('header-drawer')?.querySelector('details.menu-drawer-container');
      if (outer && !outer.open) outer.querySelector('summary').click();
      if (!drawer.open) drawer.querySelector('summary').click();
    }
  });
})();
